import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import { createUseStyles } from 'react-jss';
import { connect } from 'react-redux';
import { DEACTIVATE_PROMOTION, FETCH_PROMOTIONS } from '../../../../redux/Promotions';
import withScopedTranslations from '../../../../withScopedTranslations/withScopedTranslations';

const PromotionsList = ({ fetchPromotions, deactivatePromotion, history,
                          promotions, t, match: { params: { adId, }, }, }) => {
  useEffect(() => {
    fetchPromotions(adId);
  }, [fetchPromotions]);
  const classes = useStyles();
  if (!promotions.length) {
    return null;
  }
  return (
    <div
      className={classes.promotionsListContainer}
    >
      <h3> {t('list')} </h3>
      <table className={classes.table}>
        <thead>
          <tr>
            <th>{t('name')}</th>
            <th>{t('activation_date')}</th>
            <th>{t('price')}</th>
            <th>{t('promotions_per_type')}</th>
          </tr>
        </thead>
        <tbody>
          {promotions.map((item) => (
            <tr key={item.id}>
              <td>
                {item.channel_name}
              </td>
              <td>
                {item.created_at}
              </td>
              <td>
                {item.price} &euro;
              </td>
              <td>
                {item.promotions_per_channel}
              </td>
              <td className={classes.tools}>
                <span
                  role={'button'}
                  tabIndex={0}
                  className="material-icons"
                  onClick={() => history.push(`/dashboard/promotions/update/${item.id}`)}
                >
                  mode_edit
                </span>
                <span
                  role={'button'}
                  tabIndex={0}
                  className="material-icons"
                  onClick={() => deactivatePromotion(item.id)}
                >
                  delete
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

PromotionsList.propTypes = {
  fetchPromotions: PropTypes.func.isRequired,
  deactivatePromotion: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  promotions: PropTypes.arrayOf(PropTypes.object).isRequired,
};


const useStyles = createUseStyles({
  promotionsListContainer: {
    margin: '20px',
  },
  table: {
    width: '100%',
    marginTop: '1em',
    border: '1px solid #e5e3e8',
    borderRadious: '2px',
    '& tr, thead': {
      borderBottom: '1px solid #e5e3e8',
    },
    '& td': {
      padding: '10px',
      cursor: 'initial',
    },
    '& th': {
      padding: '5px 10px',
      width: '20%',
    },
  },
  tools: {
    display: 'flex',
    justifyContent: 'flex-end',
    '& span': {
      fontSize: '20px',
      marginRight: '8px',
      cursor: 'pointer',
    },
  },
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchPromotions: (adId) => dispatch(FETCH_PROMOTIONS(adId)),
    deactivatePromotion: (promotionId) => dispatch(DEACTIVATE_PROMOTION(promotionId)),
  };
};

export default compose(
  connect(null, mapDispatchToProps),
  withRouter,
  withScopedTranslations('ads.promotion_list')
  )(PromotionsList);

